import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// components
import Footer from "src/components/Footer/Footer";
import Hero from "../Hero/Hero";
import DetailSection from "../DetailSection/DetailSection";
import ShareSection from "../ShareSection/ShareSection";
import OtherEvents from "../RelatedBlogs/RelatedBlogs";

// mockup
import mockup from "src/utils/data";

// api
import { getBlogList } from "../api";

const DetailContent = () => {
  const { slug } = useParams();

  const [blogData, setBlogData] = useState(null);
  const [blogList, setBlogList] = useState(mockup.empty_3);

  useEffect(() => {
    getBlogList()
      .then((res) => {
        if (res.data.Status) {
          let list = res.data.Results;
          let data = list.find((item) => item.BlogLink === slug);
          setBlogList(list);
          setBlogData(data);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  console.log({ slug, blogData });

  useEffect(() => {
    if (blogData) {
      let data = blogList.find((item) => item.BlogLink === slug);
      setBlogData(data);
    }
  }, [slug]);

  return (
    <div className={styles.blog__detail__content}>
      <Hero data={blogData} />
      <div className={styles.wrapper}>
        <DetailSection blogData={blogData} />
        <ShareSection blogData={blogData} />
        <OtherEvents data={blogList} />
      </div>
      <Footer />
    </div>
  );
};

export default DetailContent;
